// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.awca {
  background: var(--c-cream);
  padding-block: var(--section-y);
  border-top: 1px solid var(--line);
}

.awca__eyebrow-row {
  display: flex; align-items: center; justify-content: center;
  gap: clamp(1rem, 3vw, 2.5rem);
  margin-bottom: clamp(2rem, 4vw, 3.5rem);
}

.awca__rule { flex: 1 1; max-width: 8rem; height: 1px; background: var(--line); display: block; }

.awca__heading {
  /* u-eyebrow handles font/size/tracking */
  color: var(--c-ink) !important;
  white-space: nowrap; flex-shrink: 0; margin: 0;
}

.awca__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: clamp(0.75rem, 1.5vw, 1.25rem);
}

.awca__card {
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: clamp(1.5rem, 2.5vw, 2.25rem) clamp(1rem, 2vw, 1.75rem);
  display: flex; flex-direction: column; align-items: center; text-align: center;
  gap: var(--sp-4);
  background: var(--c-cream);
  transition: box-shadow var(--dur) var(--ease), transform var(--dur) var(--ease);
}
.awca__card:hover { box-shadow: var(--shadow); transform: translateY(-3px); }

.awca__icon-wrap {
  width: clamp(52px, 6vw, 72px); height: clamp(52px, 6vw, 72px);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: clamp(1.2rem, 2vw, 1.6rem);
  color: rgba(255,255,255,0.9);
  flex-shrink: 0;
}

.awca__label {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: var(--track-eyebrow);
  text-transform: uppercase;
  color: var(--c-ink);
  margin: 0;
}
.awca__label--rust { color: var(--accent); }

.awca__desc {
  font-family: var(--font-body);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  line-height: var(--lh-body);
  margin: 0;
}

@media (max-width: 767.98px) { .awca__grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 479.98px) { .awca__grid { grid-template-columns: 1fr; } }

/* ── Mobile font size fixes ── */
@media (max-width: 767.98px) {
  .awca__label { font-size: var(--fs-sm); letter-spacing: 0.18em; }
  .awca__desc  { font-size: var(--fs-body); }
  .awca__icon-wrap { width: 64px; height: 64px; font-size: 1.5rem; }
}

/* ── Mobile design match ── */
@media (max-width: 767.98px) {
  .awca { padding-block: var(--sp-8); }
  .awca__eyebrow { font-size: var(--fs-body); letter-spacing: 0.2em; }
  .awca__card { padding: var(--sp-6) var(--sp-5); gap: var(--sp-4); }
  .awca__icon-wrap { width: 72px; height: 72px; font-size: 1.6rem; }
  .awca__label { font-size: var(--fs-body); }
  .awca__desc  { font-size: var(--fs-body); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ApplyWhoCanApply.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA,cAAc,SAAO,EAAE,eAAe,EAAE,WAAW,EAAE,uBAAuB,EAAE,cAAc,EAAE;;AAE9F;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,mBAAmB,EAAE,cAAc,EAAE,SAAS;AAChD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,gEAAgE;EAChE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,kBAAkB;EAC9E,gBAAgB;EAChB,0BAA0B;EAC1B,+EAA+E;AACjF;AACA,oBAAoB,yBAAyB,EAAE,2BAA2B,EAAE;;AAE5E;EACE,6BAA6B,EAAE,8BAA8B;EAC7D,kBAAkB;EAClB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,qCAAqC;EACrC,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA,qBAAqB,oBAAoB,EAAE;;AAE3C;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;AACX;;AAEA,+BAA+B,cAAc,qCAAqC,EAAE,EAAE;AACtF,+BAA+B,cAAc,0BAA0B,EAAE,EAAE;;AAE3E,iCAAiC;AACjC;EACE,eAAe,uBAAuB,EAAE,sBAAsB,EAAE;EAChE,eAAe,yBAAyB,EAAE;EAC1C,mBAAmB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AACnE;;AAEA,8BAA8B;AAC9B;EACE,QAAQ,0BAA0B,EAAE;EACpC,iBAAiB,yBAAyB,EAAE,qBAAqB,EAAE;EACnE,cAAc,gCAAgC,EAAE,gBAAgB,EAAE;EAClE,mBAAmB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;EACjE,eAAe,yBAAyB,EAAE;EAC1C,eAAe,yBAAyB,EAAE;AAC5C","sourcesContent":[".awca {\n  background: var(--c-cream);\n  padding-block: var(--section-y);\n  border-top: 1px solid var(--line);\n}\n\n.awca__eyebrow-row {\n  display: flex; align-items: center; justify-content: center;\n  gap: clamp(1rem, 3vw, 2.5rem);\n  margin-bottom: clamp(2rem, 4vw, 3.5rem);\n}\n\n.awca__rule { flex: 1; max-width: 8rem; height: 1px; background: var(--line); display: block; }\n\n.awca__heading {\n  /* u-eyebrow handles font/size/tracking */\n  color: var(--c-ink) !important;\n  white-space: nowrap; flex-shrink: 0; margin: 0;\n}\n\n.awca__grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: clamp(0.75rem, 1.5vw, 1.25rem);\n}\n\n.awca__card {\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: clamp(1.5rem, 2.5vw, 2.25rem) clamp(1rem, 2vw, 1.75rem);\n  display: flex; flex-direction: column; align-items: center; text-align: center;\n  gap: var(--sp-4);\n  background: var(--c-cream);\n  transition: box-shadow var(--dur) var(--ease), transform var(--dur) var(--ease);\n}\n.awca__card:hover { box-shadow: var(--shadow); transform: translateY(-3px); }\n\n.awca__icon-wrap {\n  width: clamp(52px, 6vw, 72px); height: clamp(52px, 6vw, 72px);\n  border-radius: 50%;\n  display: flex; align-items: center; justify-content: center;\n  font-size: clamp(1.2rem, 2vw, 1.6rem);\n  color: rgba(255,255,255,0.9);\n  flex-shrink: 0;\n}\n\n.awca__label {\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: var(--track-eyebrow);\n  text-transform: uppercase;\n  color: var(--c-ink);\n  margin: 0;\n}\n.awca__label--rust { color: var(--accent); }\n\n.awca__desc {\n  font-family: var(--font-body);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  margin: 0;\n}\n\n@media (max-width: 767.98px) { .awca__grid { grid-template-columns: repeat(2, 1fr); } }\n@media (max-width: 479.98px) { .awca__grid { grid-template-columns: 1fr; } }\n\n/* ── Mobile font size fixes ── */\n@media (max-width: 767.98px) {\n  .awca__label { font-size: var(--fs-sm); letter-spacing: 0.18em; }\n  .awca__desc  { font-size: var(--fs-body); }\n  .awca__icon-wrap { width: 64px; height: 64px; font-size: 1.5rem; }\n}\n\n/* ── Mobile design match ── */\n@media (max-width: 767.98px) {\n  .awca { padding-block: var(--sp-8); }\n  .awca__eyebrow { font-size: var(--fs-body); letter-spacing: 0.2em; }\n  .awca__card { padding: var(--sp-6) var(--sp-5); gap: var(--sp-4); }\n  .awca__icon-wrap { width: 72px; height: 72px; font-size: 1.6rem; }\n  .awca__label { font-size: var(--fs-body); }\n  .awca__desc  { font-size: var(--fs-body); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
